import React from "react";
import PropTypes from 'prop-types';

export const LinkButton = ({url, text, className, ...props}) => {
  return (
    <a className={className} href={url}>
      {text || props.children}
    </a>
  );
};

LinkButton.propTypes = {
  url: PropTypes.string.isRequired,  
};